<template>
  <BlogPostSimpleGuideOnHowToAvoidSurpriseAwsBillsMainArea/>
</template>

<script>
import BlogPostSimpleGuideOnHowToAvoidSurpriseAwsBillsMainArea from '@/components/blog/blog-post-the-simple-guide-on-how-to-avoid-surprise-aws-bills/index.vue';

export default {
  name:'BlogPostSimpleGuideOnHowToAvoidSurpriseAwsBills',
  components:{BlogPostSimpleGuideOnHowToAvoidSurpriseAwsBillsMainArea}
}
</script>
